import React from 'react';
import { Box, Text, VStack } from '@chakra-ui/react';
import { localise } from '../../../services/lang/lang';
import { useTokens } from '../../../context/TokenProvider';
import PanelContainerWithFallback from './PanelContainerWithFallback';
import NoteUserDetails from '../Notes/NoteUserDetails';
const NotesPanel = ({ notes, title = localise('NOTES'), ...rest }) => {
    const tokens = useTokens();
    const styles = {
        panelText: {
            wordBreak: 'keep-all',
            whiteSpace: 'normal',
        },
    };
    return (React.createElement(VStack, { "data-testid": "notes_panel", alignItems: "flex-start", w: "100%" },
        React.createElement(PanelContainerWithFallback, { title: title, condition: !!notes.length, fallbackText: localise('NONE_ADDED'), overflowY: "auto", w: "100%", h: rest.h ?? '330px', ...rest }, notes.map((note) => (React.createElement(Box, { mb: tokens.Spacing04, key: note.id },
            React.createElement(NoteUserDetails, { note: note }),
            React.createElement(Text, { sx: styles.panelText, variant: "md-600-rg-4", "data-testid": "notes_panel_notes" }, note.content)))))));
};
export default NotesPanel;
